
export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-sky-50 via-white to-cyan-50 py-12 sm:py-16 md:py-20 overflow-hidden">
      {/* 装飾 */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-gradient-to-br from-sky-200/40 to-cyan-200/40 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-teal-200/30 to-sky-200/30 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* テキストエリア */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="bg-gradient-to-r from-sky-500 to-cyan-500 text-white px-3 py-1 rounded-full text-xs font-bold">
                ✈️ 海外旅行特集
              </span>
              <span className="bg-sky-100 text-sky-700 px-3 py-1 rounded-full text-xs font-bold">
                2026年最新版
              </span>
            </div>
            
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-cyan-600">海外旅行</span>に
              <br className="hidden sm:block" />
              おすすめのクレジットカード
            </h1>
            
            <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8">
              海外旅行傷害保険、空港ラウンジ、海外キャッシング対応など、
              <strong className="text-gray-900">海外旅行に必須の機能</strong>を備えたクレジットカードを厳選。
              旅行好きの方に最適な1枚が見つかります。
            </p>
            
            <div className="flex flex-wrap gap-2 sm:gap-3 mb-6 sm:mb-8">
              <span className="bg-white border border-sky-200 text-sky-700 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium shadow-sm">
                #海外旅行保険
              </span>
              <span className="bg-white border border-sky-200 text-sky-700 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium shadow-sm">
                #空港ラウンジ
              </span>
              <span className="bg-white border border-sky-200 text-sky-700 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium shadow-sm">
                #海外キャッシング
              </span>
              <span className="bg-white border border-sky-200 text-sky-700 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium shadow-sm">
                #マイル還元
              </span>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-sky-500 to-cyan-500 hover:from-sky-600 hover:to-cyan-600 text-white font-bold px-6 py-3 sm:py-4 rounded-xl transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-trophy-line"></i>
                おすすめランキングを見る
              </a>
              <a
                href="#comparison"
                className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-700 font-bold px-6 py-3 sm:py-4 rounded-xl border border-gray-200 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-scales-3-line"></i>
                カードを比較する
              </a>
            </div>
          </div>
          
          {/* 画像エリア */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/4023cfa05e7d93cced9982efcfaa3b34.jpg"
                alt="海外旅行イメージ"
                className="w-full h-64 sm:h-80 lg:h-96 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            
            {/* フローティングカード */}
            <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-white rounded-xl shadow-xl p-3 sm:p-4 border border-gray-100">
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-sky-500 to-cyan-500 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500">海外旅行保険</p>
                  <p className="font-bold text-gray-900 text-sm sm:text-base">最大1億円補償</p>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-4 -right-4 sm:-top-6 sm:-right-6 bg-white rounded-xl shadow-xl p-3 sm:p-4 border border-gray-100">
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center">
                  <i className="ri-vip-crown-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500">空港ラウンジ</p>
                  <p className="font-bold text-gray-900 text-sm sm:text-base">無料利用可能</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
